export default __webpack_public_path__ + "static/media/kanzlei.ec589a8b.jpg";